export const loadFooter = () =>
    typeof window === 'undefined'
        ? { default: require('./Footer').Footer }
        : import(/* webpackChunkName: "footer" */ './Footer').then((m) => ({ default: m.Footer }));
